import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, Users, CalendarDays, FileText } from "lucide-react";
const LoesungVerbaendeSection = () => <IndustrySolutionI18n translationPrefix="industryVerbaende" icons={[Clock, Users, CalendarDays, FileText]} />;
export default LoesungVerbaendeSection;
